import React,{Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Loader from "./component/loader";

ReactDOM.render(<Suspense fallback={<Loader/>}>
        <App/>
    </Suspense>,
  document.getElementById('root')
);